<template>
    <div class="vue-oss-uploader-video-wrap" v-if="upload_show">
        <div class="vue-oss-uploader-video" :class="{ videodiv: upload_type == 0}">
            <div class="vue-oss-uploader-video-top">
                <div class="vue-oss-uploader-video-top-left">{{ upload_type_text[upload_type] }}</div>
                <div class="vue-oss-top-closes" @click="close">×</div>
            </div>
            <div class="rel clearfix">
                <div class="video-btn-local fl_left video-btn" >上传{{ upload_type_text[upload_type] }}
                <input type="file" @change="addFile" class="videoInput" ref="file"  :accept="file_types[upload_type]" >
                </div>
                <div class="loading_upload_mark" v-show="show_loading"></div>
            </div>
            <template v-if="upload_type == 1">
                <div class="vue-oss-uploader-video-content clearfix">
                    <div class="image-show fl_left"  v-for="(item,key) in file_list">
                        <img :src="item.url" alt="" @click="selectMedia(item)">
                        <!-- <div class="image-del">
                            <i @click="deleteMedia(item,key)" class="el-icon-delete" ></i>
                        </div> -->
                        <div class="mark" v-if="file_select_id == item.id"><i class="el-icon-check"></i></div>
                    </div>
                </div>
                <div class="videoBtn" @click="selectFileAndClose">确定</div>
            </template>
            <template v-else-if="upload_type == 0">
                <div class="vue-oss-uploader-video-content">
                    <div class="video-top-head clearfix">
                        <div class="fl_left video-sele" style="width:100px">选择</div>
                        <div class="fl_left video-sele" style="width:15%">封面</div>
                        <div class="fl_left video-sele" style="width:30%">视频名称</div>
                        <div class="fl_left video-sele" style="width:30%">上传时间</div>
                        <!-- <div class="fl_left video-sele" >操作</div> -->
                    </div>
                    <div style="position:relative;">
                        <template v-for=" (item,key) in file_list">
                            <div class="oss-video oss_loading_video clearfix" >
                                <div class="fl_left video-sele video-sele-z rel video-td" @click="selectMedia(item)"
                                    style="width:100px;margin:0"><span class="checkedbox"></span>
                                    <div class="mark video-mark" v-if="file_select_id == item.id"><i class="el-icon-check"></i></div>
                                </div>
                                <div class="fl_left video-sele video-td" style="width:15%">
                                    <img class="video-img" :src="item.video_img?item.video_img:'../../../static/imgs/musicadd.png'">
                                </div>
                                <div class="fl_left video-sele video-td" style="width:30%">
                                    <span  @click="editData(1,item)">{{item.title}}</span>
                                </div>
                                <div class="fl_left video-sele video-td" style="width:30%">{{item.updated_at}}
                                </div>
                                <!-- <div class="fl_left video-sele video-td">
                                    <el-button type="text" @click="deleteMedia(item,key)" size="small" >删除</el-button>
                                </div> -->
                                <div class="loading_bar" v-if="file_select_id == item.id && process_bar > 0">
                                    <div class="progress_bar_load clearfix">
                                        <div class="fl_left progress_bar_div" :style="{width:process_bar+'%'}"></div>
                                        <span style="position:absolute;right:5px;">已上传：{{process_bar+'%'}}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="videoBtn_wrap">
                    <div class="videoBtn" @click="selectFileAndClose">确定</div>
                    <div class="mark_btns" v-show="show_loading">上传中<img src="static/imgs/loading.gif" alt=""></div>
                </div>
            </template>
            <template v-else>
                <div class="vue-oss-uploader-video-content">
                    <div class="video-top-head clearfix">
                        <div class="fl_left video-sele" style="width:20%">选择</div>
                        <div class="fl_left video-sele" style="width:30%">名称</div>
                        <div class="fl_left video-sele" style="width:30%">上传时间</div>
                        <div class="fl_left video-sele" style="width:20%">操作</div>
                    </div>
                    <div style="position:relative;">
                        <div class="oss-video oss_loading_video clearfix" v-for=" (item,key) in file_list">
                            <div class="fl_left video-sele video-sele-z rel" @click="selectMedia(item)"
                                style="width:20%;margin:0"><span class="checkedbox"></span>
                                <div class="mark" v-if="file_select_id == item.id"><i class="el-icon-check"></i></div>
                            </div>
                            <div class="fl_left video-sele" style="width:30%">
                                <span @click="editData(1,item)">{{item.title}}</span>
                            </div>
                            <div class="fl_left video-sele" style="width:30%">{{item.updated_at}}
                            </div>
                            <div class="fl_left video-sele" style="width:20%">
                                <i class="el-icon-delete" @click="deleteMedia(item,key)"></i>
                            </div>
                            <div class="loading_bar" v-if="file_select_id == item.id && process_bar > 0">
                                <div class="progress_bar_load clearfix">
                                    <div class="fl_left progress_bar_div" :style="{width:process_bar+'%'}"></div>
                                    <span style="position:absolute;right:5px;">已上传：{{process_bar+'%'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="videoBtn_wrap">
                    <div class="videoBtn" @click="selectFileAndClose">确定</div>
                    <div class="mark_btns" v-show="show_loading">上传中<img src="static/imgs/loading.gif" alt=""></div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { getNowTime } from '@/utils/common'
export default {
    name:"uploadmedia",
    props:{
        upload_type:{ //类型 image—图片 video-视频 audio-音乐
            type:String | Number,
            default:0
        },
        upload_show:{ //类型 image—图片 video-视频 audio-音乐
            type:Boolean,
            default:false
        },
        issue_id:{ //课程包
            type:String | Number,
        }
    },  
    data() {
        return {
            show_loading: false,   //loading状态
            file_list: [],    //存储视频、图片、音频
            file_select:'', //选中文件
            file_select_id:'',//选中文件key
            token: '',   //分片上传token
            upload_type_list:['video','image','audio'],
            upload_tp:'video',
            file_types:['video/mp4','image/jpg,image/jpeg,image/png,image/bmp','audio/mp3'],
            process_bar:0,
            file_title:'',//临时名称
            showVideo:false, //修改父节点
            parent_id:'', //修改父节点
            uploadShow:false, //
            showImage:false,//图片展示
            img_list:'', //图片列表
            img_select:'', //选择封面的
            img_select_id:'', //选择封面的
            upload_type_text:['视频','图片','音乐'],
            child_video:[], //子视角
        }
    },
    watch:{
        upload_type() {
            this.upload_tp = this.upload_type_list[this.$props.upload_type];
            this.getFiles()
        }
    },
    methods:{
        //关闭
        close() {
            var _this = this;
            _this.file_select    = '';
            _this.file_select_id = '';
            _this.file_list = []
            _this.$emit("closeUpload");
        },
        //关闭上传框
        closeUpload(){
            let _this = this;
            _this.showImage = false;
        },

        //选择文件
        selectFileAndClose() {
            const _this = this;
            if(_this.file_select == ''){
                _this.$message.info("请选择文件1");
                return;
            }
            if (_this.file_select.id == null) {
                _this.$message.info("请选择文件1");
            } else {
                _this.$emit("checkFile",_this.file_select);
                _this.close();
            }
        },
        //添加本地文件
        addFile() {
            const _this = this;
            let   _list = "";
            _this.file_select    = '';
            _this.file_select_id = '';
            _list = this.$refs.file.files
            
            for (let i = 0; i < _list.length; i++) {
                const item = {
                    id: getNowTime(),
                    angle: "",
                    child_video: [],
                    title: _list[i].name,
                    name: _list[i].name,
                    size: _list[i].size,
                    file: _list[i],
                    updated_at:getNowTime(),
                }
                _this.html5Reader(_list[i], item)
                _this.file_list.unshift(item)
                _this.selectMedia(item);
                _this.pushUpload(item);
                
            }
        },

        // 将图片文件转成BASE64格式
        html5Reader(file, item) {
            const reader = new FileReader()
            reader.onload = (e) => {
                this.$set(item, 'src', e.target.result)
            }
            reader.readAsDataURL(file)
        },
        //触发上传操作
        pushUpload(item){
            const _this = this;
            _this.$axios.post('getuploadtoken', {
                issue_id:_this.$props.issue_id,
                name: item.name,
                size: item.size,
                type: _this.upload_tp
            }).then(res => {
                if (res.data.code == 200) {
                    _this.token = res.data.data.token
                    _this.process_bar = 0
                    _this.show_loading = true
                    _this.uploadFile(1,item)
                }
                else {
                    _this.$message.error(res.data.message)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        //上传文件
        uploadFile(num,item) {
            let _this   = this;
            let file    = item.file; 
            var blockSize = 2 * 1024 * 1024;
            var start = (num - 1) * blockSize;
            var blockNum = Math.ceil(file.size / blockSize);    //总片数
            var nextSize = Math.min(num * blockSize, file.size);   //下一片的位置
            var fileData = file.slice((num - 1) * blockSize, nextSize);   //
            _this.currentAjax = $.ajax({
                url: strUrl + "html5upload?token=" + _this.token + '&up_size=' + start,
                type: "POST",
                data: fileData,
                processData: false,
                contentType: 'application/json',
                beforeSend: function (XMLHttpRequest) {
                    XMLHttpRequest.setRequestHeader("Authorization", localStorage.getItem('Authorization'));
                },
                success: function (responseText) {
                    if (responseText.code == 200) {
                        _this.process_bar = Math.floor((num * 100) / blockNum)
                        if (file.size <= nextSize) {
                            _this.show_loading = false;
                            _this.$message.success("上传成功")
                            _this.process_bar = 0;
                            _this.getFiles();
                            return;
                        }
                        _this.uploadFile(++num,item);//递归调用
                    }
                    else if (responseText.code == 115) {
                        _this.$router.push({
                            path: '/login'
                        });
                    }
                    else {
                        _this.$message.error(responseText.data.message)
                    }
                }
            });
        },

        //点击编辑名称
        editData(type,item){
            const _this = this;
            _this.selectMedia(item);

            let _title  = ""; 
            let _deafult  = ""; 
            if(type == 1){
                _title = "视频名称";
                _deafult = item.title;
            }else if(type == 2){
                _title = "视角";
                _deafult = item.angle;
            }
            _this.$prompt('请填写'+_title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue:_deafult,
                closeOnClickModal:false,
                closeOnPressEscape:false,
            }).then(({ value }) => {
                if(value == ""){
                    _this.$message.info("请填写"+_title);
                    return false;
                }
                _this.file_title   = value;
                if(type ==1){
                    _this.saveTitle();
                }else if(type ==2){
                    _this.saveAngle();
                }
            }).catch(() => {
                
            });
        },
        //保存名称
        saveTitle(){
            const _this = this;
            if(_this.file_title == ""){
                _this.$message.info("请输入名称")
                return false;
            }
            _this.$axios.post('setmediatitle', { 
                media_id: _this.file_select.id,
                type: _this.upload_tp,
                title: _this.file_title
            }).then(res => {
                if (res.data.code == 200) {
                    _this.$message.success("保存名称成功");
                    _this.file_select.title  = _this.file_title;
                }
                else {
                    _this.$message.error(res.data.message)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        //保存视角
        saveAngle(){
            const _this = this;
            if(_this.file_title == ""){
                _this.$message.info("请输入视角名称");
                return false;
            }
            _this.$axios.post('setmediaangle', { 
                media_id: _this.file_select.id,
                angle: _this.file_title
            }).then(res => {
                if (res.data.code == 200) {
                    _this.$message.success("保存视角成功");
                    _this.file_select.angle  = _this.file_title;
                }
                else {
                    _this.$message.error(res.data.message)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        //设置父节点
        setMediaParent(item){
            const _this = this;
            _this.child_video = [];
            _this.file_list.forEach(e => {
                if(e.child_video.length == 0){
                    _this.child_video.push(e);
                }else{
                    e.child_video.forEach(ce => {
                        _this.child_video.push(ce);
                    });
                }
            });

            _this.showVideo = true;
            _this.selectMedia(item);
        },
        //设置父节点
        saveMediaParent(){
            const _this = this;
            if(_this.parent_id == ""){
                _this.$message.info("请选择子节点");
                return false;
            }
            _this.$axios.post('setmediaparent', { 
                media_id: _this.parent_id,
                parent_id: _this.file_select.id,
            }).then(res => {
                if (res.data.code == 200) {
                    _this.$message.success("保存节点成功");
                    _this.showVideo = false;
                    _this.getFiles()
                }
                else {
                    _this.$message.error(res.data.message)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        //查看子节点
        showChild(item){
            this.$set(item,"showChild",item.showChild?false:true);
        },
        //设置封面
        setVideoImg(item){
            const _this = this;
            _this.selectMedia(item);
            _this.showImage = true;
        },
        //保存设置封面
        saveVideoImg(file){
            const _this = this;
            _this.$axios.post('setmediacoverimage', { 
                media_id: _this.file_select.id,
                video_img: file.object_urls.original_url
            }).then(res => {
                if (res.data.code == 200) {
                    _this.$message.success("保存封面图成功");
                    _this.getFiles()
                }
                else {
                    _this.$message.error(res.data.message)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        //点击选择
        selectMedia(item) {
            this.file_select    = item;
            this.file_select_id = item.id;
        },
        //转换二进制
        /*
        dataURLtoBlob(dataURI, type) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: type });
        },
        */

        //获取资源
        getFiles() {
            let _this = this;
            _this.file_list = []
            _this.file_select    = '';
            _this.file_select_id = '';
            _this.$axios.post('getallmdedia', {
                type: _this.upload_tp,
                issue_id: _this.$props.issue_id
            }).then(res => {
                if (res.data.code == 200) {
                    _this.file_list = res.data.data;
                }
                else {
                    _this.$message.error(res.data.message)
                }
            })
        },
        //删除资源
        deleteMedia(item,key){
            let _this=this;
            _this.$confirm('确认删除此文件吗？此操作不可恢复，请确认', '删除提示', {
                onfirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$axios.post('deletemedia',{
                    media_id:item.id
                }).then((res)=>{
                    if(res.data.code == 200)
                    {
                        _this.$message({type: 'success',message: '删除成功!'});
                        _this.getFiles();
                    }else{
                        _this.$message.error(res.data.message)
                    }
                }).catch((err)=>{
                    console.log(err)
                })
            }).catch((error) => {     
            });	
        },
    },
    created() {
        this.upload_tp  = this.upload_type_list[this.$props.upload_type];
        this.getFiles()
    }
}
</script>
<style>
.ivu-input{
    border-radius: 2px;
    border: 1px solid #ccc;
}
.ivu-input:hover{
    border-radius: 2px;
    border: 1px solid #ccc;
}
</style>
<style scoped>
/*oss资源库*/
.vue-oss-uploader-wrap{position:fixed;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);width:100%;height:100%;background:rgba(0,0,0,.5)}
.video-btn{cursor:pointer}
.videoInput{width:70px;height:30px;opacity:0;position:absolute;top:6px;left:4px;cursor:pointer;z-index:99}
.video-top-head{width:100%;margin:10px auto 0;height:32px;background:#f4f4f4;font-size:14px;color:#333}
.video-sele{text-align:center;line-height:32px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative}
.video-sele-z{width:90px;text-align:center;line-height:32px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0 5px}
.mark{width:14px;height:14px;line-height:14px;color:#01ab6c;position:absolute;top:10px;left:50px;z-index:999;display:block}
.checkedbox{width:16px;height:16px;border:1px solid #d3d5d9;display:inline-block;vertical-align:middle}
.oss-video{border:1px solid #f4f4f4;border-top:0;width:100%;margin:0 auto;box-sizing:border-box;cursor:pointer;position:relative}
.image-show{width:180px;height:136px;cursor:pointer;margin-bottom:20px;margin-left:10px;margin-top:3px;position:relative;display:flex;justify-content:center;align-items:center;box-shadow:rgba(18,109,154,.4) 0 0 4px 1px}
.image-show img{max-width:180px;max-height:136px}
.image-show .mark{width:180px;height:136px;background:rgba(0,0,0,.2);font-size:40px;position:absolute;font-weight:700;top:0;left:0;color:#fff;line-height:136px;text-align:center}
.videoBtn_wrap{position:absolute;bottom:20px;right:20px;height:32px;width:132px}
.mark_btns{position:absolute;top:0;left:0;width:132px;height:32px;box-sizing:border-box;padding-top:5px;text-align:center;background:rgba(197,197,197,.9);cursor:not-allowed}
.oss-loading-mark{position:absolute;top:0;left:0;background:0 0;width:100%;height:100%;cursor:not-allowed}
.loading_bar{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,.6)}
.progress_bar_load{line-height:50px;position:relative}
.progress_bar_div{border:none;line-height:50px;background:#52928f;height:50px;opacity:.7}
.loading_upload_mark{position:absolute;top:0;left:0;background:0 0;width:100%;height:100%;cursor:not-allowed}
.miuse_tep{width:142px;height:43px;margin-bottom:8px;box-sizing:border-box;border:1px solid #ffbe70;border-radius:8px;color:#ffbe70;line-height:43px;text-align:center;margin-left:5px;cursor:pointer;position:relative}
.videodiv{width:50%}
.video-img{height:40px;width:40px;object-fit:cover;border-radius:5px;margin-top:5px;border:1px solid #52928f}
.video-mark{left:42px;top:20px}
.child-video{background:#e0ffff}
.video-td{height:50px;line-height:50px}
.image-del{position:absolute;top:0;background:rgba(0,0,0,.5);width:100%;text-align:right;padding-right:10px;color:#fff}

</style>


// WEBPACK FOOTER //
// src/components/media/upload.vue